export default {"src":"https://fishbrain.com/_next/static/media/footerWave.316ebbad.svg","height":171,"width":1440,"blurWidth":0,"blurHeight":0};